import React from 'react';
import ManageEventGalleryForm from '../../features/EventsGallery/ManageEventGalleryForm';

const ManageEventGallery= () => {
    return (<>
        < ManageEventGalleryForm/>
    </>)
}
export default ManageEventGallery;